import { render, staticRenderFns } from "./RegistrationOptions.vue?vue&type=template&id=2a4ec79b&"
import script from "./RegistrationOptions.vue?vue&type=script&lang=js&"
export * from "./RegistrationOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports